"use client";

import { useEffect, useState } from "react";
import { isBeforeReopening } from "@/config/registration";

/**
 * Pill announcing the temporary reopening of inscriptions.
 * Evaluated on the client so it disappears automatically at the reopening
 * moment (REGISTRATION_DATES.REOPENING_DATE) without needing a rebuild.
 */
export default function ReopeningBanner({ className = "" }: { className?: string }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(isBeforeReopening());
    }, []);

    if (!visible) return null;

    return (
        <span className={`inline-block bg-secondary text-white font-accent uppercase tracking-wider text-xs md:text-sm px-5 py-2 rounded-full shadow-md shadow-secondary/30 ${className}`}>
            Reabrimos inscripciones el miércoles 16/9 a las 21:00h
        </span>
    );
}
